import PropTypes from 'prop-types';
import { Box, Typography, Chip, Button, Stack } from '@mui/material';
import { brandColors } from '../../constants/brandColors';

/**
 * Aside sticky com saldo, pré-visualização e botão de pacotes.
 * Fica ao lado (lg+) ou abaixo (md↓) do bloco de config.
 */
export default function WhatsAppPreviewAside({
  selectedModel,
  messageNotes,
  waBalance,
  onScrollToCatalog,
}) {
  const trimmedNotes = messageNotes?.trim();
  const messagePreview = selectedModel
    ? (trimmedNotes
        ? (selectedModel.previewCreatedWithNotes || '').replace('{{ORIENTACOES}}', trimmedNotes)
        : (selectedModel.previewCreated || ''))
    : 'Pré-visualização indisponível.';

  return (
    <Box
      sx={{
        position: { lg: 'sticky' },
        top: { lg: 16 },
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {/* Strip de saldo */}
      <Stack spacing={1}>
        <Chip
          color="success"
          variant="outlined"
          label={`Saldo: ${waBalance ?? 0} créditos`}
          sx={{ alignSelf: 'flex-start' }}
        />
      </Stack>

      {/* Pré-visualização */}
      <Box>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
          Pré-visualização — agendamento criado
        </Typography>
        <Box
          sx={{
            bgcolor: brandColors.whatsapp.bubble,
            border: '1px solid',
            borderColor: 'success.light',
            borderRadius: 2,
            p: 2,
            whiteSpace: 'pre-line',
            fontSize: 14,
            lineHeight: 1.5,
            minHeight: 140,
          }}
        >
          {messagePreview}
        </Box>
      </Box>

      {/* Botão Ver Pacotes */}
      <Button
        variant="outlined"
        color="success"
        onClick={onScrollToCatalog}
        fullWidth
      >
        Ver pacotes
      </Button>
    </Box>
  );
}

WhatsAppPreviewAside.propTypes = {
  selectedModel: PropTypes.object,
  messageNotes: PropTypes.string,
  waBalance: PropTypes.number,
  onScrollToCatalog: PropTypes.func.isRequired,
};
